export class AppError extends Error {
  title: string

  constructor({ title, message }: { title: string; message?: string }) {
    super()
    this.title = title
    if (message) this.message = message
  }
}

export type ResponseErrorData = {
  type: string
  message: string
}

export class ApiRequestError extends Error {
  status: number
  type: string
  message: string

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(body: any, response: Response) {
    super()

    this.name = "ApiRequestError"
    this.status = response.status
    this.type = body.type ?? "ApiRequestError"
    this.message = body.message || body.detail || "Unknown error"
  }
}

export class ExpiredTokenError extends AppError {
  constructor(message?: string) {
    super({
      title: "Sesión expirada",
    })

    this.message =
      message ??
      "La sesión para firmar el documento ha expirado. Para continuar debe acceder al link disponible en su correo electrónico"

    this.name = "ExpiredTokenError"
  }
}
